import {desktopDto} from '@vectronic/desktop-api'
import {
  _ItemGeneric as Item,
  _DeviceItemGeneric,
  _GroupItemGeneric,
  _MemberItemGeneric,
  _RegisterItemGeneric,
  _SingleItemGeneric,
  _ToGroupItemGeneric,
  _ToMemberItemGeneric,
} from './item.generic'

export class ItemHelpGeneric {
  static device() {
    return [
      Item.COLLAR,
      Item.TRAP,
      Item.DROP_OFF,
      Item.EXTERNAL_SENSOR,
      Item.CAMERA,
      Item.CONFIGURATION_DEVICE,
      Item.DATA_LOGGER,
      Item.TT4_SENSOR,
    ] as const
  }
  static single() {
    return [...this.device(), Item.ANIMAL] as const
  }
  static group() {
    return [Item.ANIMAL_GROUP, Item.COLLAR_GROUP, Item.TRAP_GROUP] as const
  }
  static member() {
    return [Item.ANIMAL, Item.COLLAR, Item.TRAP] as const
  }
  static register() {
    return [Item.COLLAR, Item.TRAP] as const
  }
  static deploy() {
    return [Item.COLLAR, Item.ANIMAL] as const
  }
  static treeview() {
    return [...this.member()] as const
  }
  static all() {
    return [...this.single(), ...this.group()] as const
  }

  static isCollarConnection(
    deviceConnection: desktopDto.DeviceConnection,
  ): deviceConnection is desktopDto.DeviceConnection<Item.COLLAR> {
    return deviceConnection?.deviceItem === Item.COLLAR
  }

  static toOpenApiTag(target: _SingleItemGeneric) {
    if (target === Item.TT4_SENSOR) return 'TT4Sensors'
    const [firstLetter] = target
    return firstLetter.toUpperCase() + `${target}s`.slice(1)
  }

  static toGroup<T extends _MemberItemGeneric>(target: T): _ToGroupItemGeneric<T> {
    return this._toGroup(target) as any
  }
  private static _toGroup(target: _MemberItemGeneric) {
    switch (target) {
      case Item.ANIMAL:
        return Item.ANIMAL_GROUP
      case Item.COLLAR:
        return Item.COLLAR_GROUP
      case Item.TRAP:
        return Item.TRAP_GROUP
    }
  }

  static toMember<T extends _GroupItemGeneric>(target: T): _ToMemberItemGeneric<T> {
    return this._toMember(target) as any
  }
  private static _toMember(target: _GroupItemGeneric) {
    switch (target) {
      case Item.ANIMAL_GROUP:
        return Item.ANIMAL
      case Item.COLLAR_GROUP:
        return Item.COLLAR
      case Item.TRAP_GROUP:
        return Item.TRAP
    }
  }

  static isMember(target: Item): target is _MemberItemGeneric {
    return this.member().includes(target as any)
  }
  static isGroup(target: Item): target is _GroupItemGeneric {
    return this.group().includes(target as any)
  }
  static isDevice(target: Item): target is _DeviceItemGeneric {
    return this.device().includes(target as any)
  }
  static hasColor(target: Item): target is Item.ANIMAL | Item.COLLAR {
    return target === Item.ANIMAL || target === Item.COLLAR
  }
  static isRegister(target: Item): target is _RegisterItemGeneric {
    return target === Item.TRAP || target === Item.COLLAR
  }
  static isCollar(target: Item): target is Item.COLLAR {
    return target === Item.COLLAR
  }
  static isAnimal(target: Item): target is Item.ANIMAL {
    return target === Item.ANIMAL
  }
  static isTrap(target: Item): target is Item.TRAP {
    return target === Item.TRAP
  }
}
